// Shared between the server (`organization.revealProvider` BAD_REQUEST
// causes) and web_client (`parseRevealProviderError`). The API error
// formatter lifts a coded BAD_REQUEST cause to `shape.data.cause`, so these
// codes are what the client matches on to pick a user-facing message.
export enum ProviderRevealErrorCode {
  MonthlyLimitReached = "MONTHLY_PROVIDER_REVEAL_LIMIT_REACHED",
  ProviderNotSharedWithBusinessUnit = "PROVIDER_NOT_SHARED_WITH_BUSINESS_UNIT",
}

export const MONTHLY_PROVIDER_REVEAL_LIMIT_MESSAGE =
  "Monthly provider reveal limit reached";
export const PROVIDER_NOT_SHARED_WITH_BUSINESS_UNIT_MESSAGE =
  "Provider is not shared with this business unit";
